var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 8.875C8.875 9.7038 9.20424 10.4987 9.79029 11.0847C10.3763 11.6708 11.1712 12 12 12C12.8288 12 13.6237 11.6708 14.2097 11.0847C14.7958 10.4987 15.125 9.7038 15.125 8.875C15.125 8.0462 14.7958 7.25134 14.2097 6.66529C13.6237 6.07924 12.8288 5.75 12 5.75C11.1712 5.75 10.3763 6.07924 9.79029 6.66529C9.20424 7.25134 8.875 8.0462 8.875 8.875Z",
    stroke: "#9EA9B8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.625C13.6576 2.625 15.2473 3.28348 16.4194 4.45558C17.5915 5.62768 18.25 7.2174 18.25 8.875C18.25 11.7142 14.0217 18.8333 12.5208 21.0958C12.4638 21.1818 12.3864 21.2523 12.2955 21.3011C12.2047 21.3498 12.1031 21.3754 12 21.3754C11.8969 21.3754 11.7953 21.3498 11.7045 21.3011C11.6136 21.2523 11.5362 21.1818 11.4792 21.0958C9.97833 18.8333 5.75 11.7142 5.75 8.875C5.75 7.2174 6.40848 5.62768 7.58058 4.45558C8.75268 3.28348 10.3424 2.625 12 2.625V2.625Z",
    stroke: "#9EA9B8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.e2833cb0d7148f3204550d8e8e89c736.svg";
export { ForwardRef as ReactComponent };